import React from 'react';

export const PageSkeleton: React.FC = () => {
  return (
    <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 min-h-[70vh] flex flex-col animate-pulse">
      {/* Header Skeleton */}
      <div className="w-full max-w-3xl mx-auto space-y-4 mb-16 text-center flex flex-col items-center">
        <div className="h-4 w-32 bg-slate-200 dark:bg-slate-800 rounded-full"></div>
        <div className="h-12 w-3/4 sm:w-2/3 bg-slate-200 dark:bg-slate-800 rounded-lg"></div>
        <div className="h-4 w-1/2 bg-slate-200 dark:bg-slate-800 rounded-full mt-4"></div>
      </div>

      {/* Grid Skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 w-full">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <div key={i} className="card-bento bg-slate-50 dark:bg-slate-900/40 p-6 sm:p-8 border border-slate-100 dark:border-slate-800 rounded-2xl">
            <div className="w-12 h-12 bg-slate-200 dark:bg-slate-800 rounded-xl mb-6"></div>
            <div className="h-6 w-3/4 bg-slate-200 dark:bg-slate-800 rounded-md mb-4"></div>
            <div className="h-4 w-full bg-slate-200 dark:bg-slate-800 rounded-md mb-2"></div>
            <div className="h-4 w-5/6 bg-slate-200 dark:bg-slate-800 rounded-md mb-6"></div>
            <div className="h-8 w-1/3 bg-slate-200 dark:bg-slate-800 rounded-lg"></div>
          </div>
        ))}
      </div>
    </div>
  );
};
